import { render } from "./ShellMenu.vue?vue&type=template&id=1e8c8e66&scoped=true&ts=true"
import script from "./ShellMenu.vue?vue&type=script&lang=ts"
export * from "./ShellMenu.vue?vue&type=script&lang=ts"

import "./ShellMenu.vue?vue&type=style&index=0&id=1e8c8e66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8c8e66"]])

export default __exports__